import Vue from 'vue'
import Router from 'vue-router'
import { formatTenantPath, formatRouteTenantPath } from '@/utils'
import { connect } from "@/websockets/client.js"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [{
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () =>
                import ('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    redirect: 'pages/comingsoon'
                },
                {
                    path: formatTenantPath('/'),
                    redirect: formatRouteTenantPath('/instances/list/choose-instance')
                },
                {
                    path: formatTenantPath('/dashboard/analytics'),
                    name: 'dashboard-analytics',
                    component: () =>
                        import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/dashboard/control-panel'),
                    name: 'dashboard-control-panel',
                    component: () =>
                        import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/dashboard/report'),
                    name: 'dashboard-report',
                    component: () =>
                        import ('./views/report/Report.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/dashboard/report-order'),
                    name: 'dashboard-report-order',
                    component: () =>    
                        import ('./views/report/ReportOrder.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/dashboard/security-report'),
                    name: 'dashboard-security-report',
                    component: () =>
                        import ('./views/report/SecurityReport.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'check'
                    }
                },

                {
                    path: formatTenantPath('/dashboard/report-nps'),
                    name: 'dashboard-report-nps',
                    component: () =>
                        import ('./views/report/ReportNPS.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'check'
                    }
                },

                {
                    path: formatTenantPath('/dashboard/report-new'),
                    name: 'dashboard-report-new',
                    component: () => import('./views/report/DashboardReport.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'check'
                    }
                },
                // =============================================================================
                // BACKOFFICE ELEMENTS
                // =============================================================================
                {
                    path: formatTenantPath('/users/list'),
                    name: 'users-list',
                    component: () =>
                        import ('@/views/users/UsersList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Usuários' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Usuários',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/two-factor'),
                    name: 'two-factor',
                    component: () =>
                        import ('@/views/users/TwoFactor.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/customers/list'),
                    name: 'customers-list',
                    component: () =>
                        import ('@/views/customers/CustomersList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Contatos' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Contatos',
                        rule: 'check'
                    }
                },                {
                    path: formatTenantPath('/customers/listt'),
                    name: 'customers-list',
                    component: () =>
                        import ('@/views/customers/CustomersList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Contatos' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Contatos',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/catalog/add'),
                    name: 'catalog-add',
                    component: () =>
                        import ('@/views/customer-groups/CustomerCategoryList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Catálogo' },
                            { title: 'Categorias', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Criar Item',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-rules'),
                    name: 'relationship-rules-list',
                    component: () =>
                        import ('@/views/relationship-rules/List.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Réguas de Relacionamento', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Réguas de Relacionamento',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-rules/new'),
                    name: 'relationship-rules-new',
                    component: () =>
                        import ('@/views/relationship-rules/New.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Réguas de Relacionamento', url: formatRouteTenantPath('/messaging/relationship-rules') },
                            { title: 'Nova', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Nova Régua de Relacionamento',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-rules/:id/edit'),
                    name: 'relationship-rules-update',
                    component: () =>
                        import ('@/views/relationship-rules/Edit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Réguas de Relacionamento', url: formatRouteTenantPath('/messaging/relationship-rules') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Régua de Relacionamento',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-templates'),
                    name: 'relationship-templates-list',
                    component: () =>
                        import ('@/views/relationship-templates/List.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Modelos de Mensagem', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Modelos de Mensagem',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-templates/new'),
                    name: 'relationship-templates-new',
                    component: () =>
                        import ('@/views/relationship-templates/New.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Modelos de Mensagem', url: formatRouteTenantPath('/messaging/relationship-templates') },
                            { title: 'Nova', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Novo Modelo de Mensagem',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-templates/:id/edit'),
                    name: 'relationship-templates-update',
                    component: () =>
                        import ('@/views/relationship-templates/Edit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Modelos de Mensagem', url: formatRouteTenantPath('/messaging/relationship-templates') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Modelo de Mensagem',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-rules-categories'),
                    name: 'category-list',
                    component: () =>
                        import ('@/views/relationship-rules-categories/List.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Categorias', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Categorias',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-rules-categories/add'),
                    name: 'category-add',
                    component: () =>
                        import ('@/views/relationship-rules-categories/New.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Categorias', url: formatRouteTenantPath('/messaging/relationship-rules-categories') },
                            { title: 'Nova', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Nova Categoria',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/messaging/relationship-rules-categories/:id/edit'),
                    name: 'category-update',
                    component: () =>
                        import ('@/views/relationship-rules-categories/Edit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Categorias', url: formatRouteTenantPath('/messaging/relationship-rules-categories') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Categoria',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/reasons'),
                    name: 'reasons-list',
                    component: () =>
                        import ('@/views/reasons/List.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mensageria' },
                            { title: 'Métrica Inteligente', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Métrica Inteligente',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/reasons/new'),
                    name: 'reasons-new',
                    component: () =>
                        import ('@/views/reasons/New.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Métrica Inteligente', url: formatRouteTenantPath('/crm/reasons') },
                            { title: 'Novo', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Nova Métrica Inteligente',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/reasons/:id/edit'),
                    name: 'reasons-update',
                    component: () =>
                        import ('@/views/reasons/Edit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Métrica Inteligente', url: formatRouteTenantPath('/crm/reasons') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Métrica Inteligente',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/category'),
                    name: 'category-list',
                    component: () =>
                        import ('@/views/customer-groups/CustomerCategoryList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Categorias', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Categorias',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/category/add'),
                    name: 'category-add',
                    component: () =>
                        import ('@/views/customer-groups/CustomerCategoryForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Categorias', url: formatRouteTenantPath('/crm/category') },
                            { title: 'Adicionar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Adicionar Categoria',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/category/edit/:id'),
                    name: 'category-update',
                    component: () =>
                        import ('@/views/customer-groups/CustomerCategoryForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Categorias', url: formatRouteTenantPath('/crm/category') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Categoria',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/schedules'),
                    name: 'scheduled-message-list',
                    component: () =>
                        import('@/views/schedules/SchedulesList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Mensagens Agendadas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Listagem de Mensagens Agendadas',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/schedules/edit/:id'),
                    name: 'scheduled-message-update',
                    component: () =>
                        import ('@/views/schedules/SchedulesViewSidebar.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Mensagens Agendadas', url: formatRouteTenantPath('/crm/schedules') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Mensagem Agendada',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/sender/emails'),
                    name: 'email-list',
                    component: () =>
                        import('@/views/campaign-sender-emails/TableSenderEmail.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Email dos Remetentes', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Email dos Remetentes',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/domain/emails'),
                    name: 'domain-list',
                    component: () =>
                        import('@/views/domains/Domain.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Domínios de Email', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Domínios de Email',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/crm/domain/create'),
                    name: 'domain-auth',
                    component: () =>
                        import('@/views/domains/HandleDomainStage.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'CRM' },
                            { title: 'Domínios de Email', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Domínios de Email',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/catalog/itens'),
                    name: 'catalog-itens',
                    component: () =>
                        import('@/views/catalog/ItensCatalog.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Catálogo' },
                            { title: 'Itens do Catálogo', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Itens do Catálogo',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/catalog/collections'),
                    name: 'catalog-collections',
                    component: () =>
                        import('@/views/catalog/ColletionsCatalog.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Catálogo' },
                            { title: 'Coleções dos Itens do Catálogo', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Coleções',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/catalog/infos'),
                    name: 'catalog-infos',
                    component: () => import('@/views/catalog/infos/Index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Coleções' },
                            { title: 'Conheça Mais', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Conheça Mais',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/orders/infos'),
                    name: 'orders-infos',
                    component: () => import('@/views/orders/infos/Index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Pedidos' },
                            { title: 'Conheça Mais', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Conheça Mais',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/campaign/sms/infos'),
                    name: 'sms-campaign-infos',
                    component: () => import('@/views/sms-campaign/infos/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Campanhas por SMS' },
                            { title: 'Conheça Mais', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Conheça Mais',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/campaign/email/infos'),
                    name: 'email-campaign-infos',
                    component: () => import('@/views/email-campaign/infos/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Campanhas por Email' },
                            { title: 'Conheça Mais', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Conheça Mais',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/orders/product-orders'),
                    name: 'product-orders',
                    component: () => import('@/views/orders/product-orders/ProductOrders.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Pedidos' },
                            { title: 'Listagem Pedidos', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Listagem Pedidos',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/orders/pre-orders'),
                    name: 'product-pre-orders',
                    component: () => import('@/views/orders/pre-orders/PreOrders.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Pedidos' },
                            { title: 'Orçamento', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Orçamento',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/orders/products'),
                    name: 'products',
                    component: () => import('@/views/orders/products/Products.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Pedidos' },
                            { title: 'Produtos', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Produtos',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/orders/status'),
                    name: 'status',
                    component: () => import('@/views/orders/status/Status.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Pedidos' },
                            { title: 'Status de Pedidos', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Status de Pedidos',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/orders/services'),
                    name: 'services',
                    component: () => import('@/views/orders/services/Services.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Pedidos' },
                            { title: 'Serviços', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Serviços',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/orders/erp-integrations'),
                    name: 'erp-integration',
                    component: () => import('@/views/orders/erp-integrations/ErpIntegration.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Pedidos' },
                            { title: 'Integrações ERP', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Integrações ERP',
                        rule: 'check'
                    }
                },
                { 
                    path: formatTenantPath('customers/knowledge/list'),
                    name: 'knowledge-list',
                    component: () =>
                      import ('@/views/knowledge/List.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Publico Alvo' },
                            { title: 'Modelo de Dados do Cliente', url: formatRouteTenantPath('/knowledge/list') },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Modelo de Dados do Cliente',
                        rule: 'check'
                    }
                }, 
                {
                    path: formatTenantPath('/whatsapp/campaigns'),
                    name: 'whatsapp-campaigns',
                    component: () =>
                        import ('@/views/campaigns/Campaigns.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'WhatsApp' },
                            { title: 'Campanhas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Campanhas WhatsApp',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/whatsapp/campaigns/add'),
                    name: 'whatsapp-campaigns-add',
                    component: () =>
                        import ('@/views/campaigns/ViewCampaign.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'WhatsApp' },
                            { title: 'Campanhas', url: formatRouteTenantPath('/whatsapp/campaigns') },
                            { title: 'Adicionar Nova', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Adicionar Campanha WhatsApp',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/whatsapp/campaigns/edit/:id'),
                    name: 'whatsapp-campaigns-update',
                    component: () =>
                        import ('@/views/campaigns/ViewCampaign.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'WhatsApp' },
                            { title: 'Campanhas', url: formatRouteTenantPath('/whatsapp/campaigns') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Atualizar Campanha WhatsApp',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/sms/campaigns'),
                    name: 'sms-campaigns',
                    component: () =>
                        import ('@/views/campaigns/SmsCampaings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Sms' },
                            { title: 'Campanhas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Campanhas Sms',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/sms/campaigns/add'),
                    name: 'sms-campaigns-add',
                    component: () =>
                        import ('@/views/campaigns/ViewCampaign.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Sms' },
                            { title: 'Campanhas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Campanhas Sms',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/email/campaigns'),
                    name: 'email-campaigns',
                    component: () =>
                        import ('@/views/campaigns/EmailCampaings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Email' },
                            { title: 'Campanhas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Campanhas Email',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/email/campaigns/add'),
                    name: 'email-campaigns-add',
                    component: () =>
                        import ('@/views/campaigns/ViewCampaign.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Email' },
                            { title: 'Campanhas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Campanhas Email',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/instances/list/:chooseInstance'),
                    name: 'instances-list',
                    component: () =>
                        import ('@/views/instances/InstancesList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Conexões' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Conexões',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/instances/build/:id'),
                    name: 'instance-build',
                    component: () =>
                        import ('@/views/instances/BuildInstance.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Conexões' },
                            { title: 'Lista', url: formatRouteTenantPath('/instances/list/choose-instance') },
                            { title: 'Integrar Conexão', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Integrar Conexão',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/instances/edit/:id'),
                    name: 'instance-edit',
                    component: () =>
                        import ('@/views/instances/EditInstance.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Conexões' },
                            { title: 'Lista', url: formatRouteTenantPath('/instances/list/choose-instance') },
                            { title: 'Editar Conexão', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Conexão',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/customers/list'),
                    name: 'customers-list',
                    component: () =>
                      import ('@/views/customers/CustomersList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Público Alvo' },
                            { title: 'Contatos' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Contatos',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/numbers-blacklist/list'),
                    name: 'numbers-blacklist-list',
                    component: () =>
                        import ('@/views/numbers-blacklist/NumbersBlacklistList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Público Alvo' },
                            { title: 'Contatos Bloqueados' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Contatos Bloqueados',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/knowledge/add'),
                    name: 'knowledge-add',
                    component: () =>
                      import ('@/views/knowledge/New.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Público Alvo' },
                            { title: 'Modelo de Dados do Cliente', url: formatRouteTenantPath('/knowledge/list') },
                            { title: 'Adicionar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Modelo de Dados do Cliente',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/knowledge/edit/:id'),
                    name: 'knowledge-update',
                    component: () =>
                      import ('@/views/knowledge/Edit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Público Alvo' },
                            { title: 'Modelo de Dados do Cliente', url: formatRouteTenantPath('/knowledge/list') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Modelo de Dados do Cliente',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/help/training-videos'),
                    name: 'help-training-videos',
                    component: () =>
                        import ('@/views/help/training-videos/TrainingVideos.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Ajuda' },
                            { title: 'Vídeos de Treinamento', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Vídeos de Treinamento',
                        rule: 'check'
                    }
                },
                // {
                //     path: formatTenantPath('/help/user-manual'),
                //     name: 'help-user-manual',
                //     component: () => import('@/views/help/user-manual/UserManual.vue'),
                //     meta: {
                //         breadcrumb: [
                //             { title: 'Home', url: formatRouteTenantPath('/') },
                //             { title: 'Ajuda'},
                //             { title: 'Manual de Uso', active: true }
                //         ],
                //         authRequired: true,
                //         pageTitle: 'Manual de Uso',
                //         rule: 'check'
                //     }
                // },
                {
                    path: formatTenantPath('/help/whatsapp-protocol'),
                    name: 'help-whatsapp-protocol',
                    component: () =>
                        import ('@/views/help/whatsapp-protocol/WhatsAppProtocol.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Ajuda' },
                            { title: 'Protocolo do WhatsApp', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Protocolo do WhatsApp',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/help/support'),
                    name: 'help-support',
                    component: () =>
                        import ('@/views/help/support/Support.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Ajuda' },
                            { title: 'Suporte', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Suporte',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/help/rules'),
                    name: 'rules',
                    component: () =>
                        import ('@/views/help/rules/Rules.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Regras', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Regras',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/configs/contract-proposal-pdf'),
                    name: 'configs-contract-proposal-pdf',
                    component: () =>
                        import ('@/views/configs/ContractProposalPdf.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Termos de Uso', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Termos de Uso',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/configs/dynamic-settings'),
                    name: 'configs-dynamic-settings',
                    component: () =>
                        import ('@/views/configs/DynamicSettings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Ajustes', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Ajustes',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/configs/closing-messages'),
                    name: 'settings-messages-closure',
                    component: () =>
                        import ('@/views/messages/Settings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Bot de Encerrar Atendimento', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Bot de Encerrar Atendimento',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/configs/nps-messages'),
                    name: 'settings-messages-nps',
                    component: () =>
                        import ('@/views/messages/MessageNPS.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Bot de NPS', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Bot de NPS',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/configs/inactive-messages'),
                    name: 'settings-messages-inactive',
                    component: () =>
                        import ('@/views/messages/MessageInactive.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Bot de Inatividade', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Bot de Inatividade',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/configs/inactive-inbox-messages'),
                    name: 'settings-messages-inactive-inbox',
                    component: () =>
                        import ('@/views/messages/MessageInactiveInbox.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Bot Inatividade Caixa', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Bot de Inatividade da Caixa de Entrada',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/configs/quick-answers'),
                    name: 'settings-messages-quick',
                    component: () =>
                        import ('@/views/messages/MessageTemplate.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Respostas Rápidas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Respostas Rápidas',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/configs/client-form'),
                    name: 'configs-client-form',
                    component: () =>
                        import ('@/views/configs/ClientForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Informações da Loja', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Informações da Loja',
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/chat-flows/:type/list'),
                    name: 'chat-flows-passive-list',
                    component: () =>
                        import ('@/views/chat-flows/ChatFlowsList.vue'),
                    props: () => ({ type: 'passive' }),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Bot de Triagem', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Bot de Triagem',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/chat-flows-active/:type/list'),
                    name: 'chat-flows-active-list',
                    component: () =>
                        import ('@/views/chat-flows/ChatFlowsList.vue'),
                    props: () => ({ type: 'active' }),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Bot de Campanhas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Bot de Campanhas',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/new-chat-flows/triage/list'),
                    name: 'new-chat-flows-triage-list',
                    component: () =>
                        import ('@/views/new-chat-flows/NewChatFlowsList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mar.IA' },
                            { title: 'Dados do Negócio', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Mar.IA',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/new-chat-flows/promotions/list'),
                    name: 'new-chat-flows-promotions-list',
                    component: () =>
                        import ('@/views/new-chat-flows/PromotionsList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mar.IA' },
                            { title: 'Promoções', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Mar.IA',
                        rule: 'check'
                    }
                },
                // manter comentado
                /*{
                    path: formatTenantPath('/new-chat-flows/infos'),
                    name: 'new-chat-flows-infos',
                    component: () =>
                        import('@/views/new-chat-flows/infos/IndexInfos.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Mar.IA' },
                            { title: 'Conheça Mais', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Conheça Mais',
                        rule: 'all'
                    }
                },*/
                {
                    path: formatTenantPath('/chat/attendance'),
                    name: 'chat-attendance',
                    component: () =>
                        import ('@/views/chat-attendance/Index.vue'),
                    meta: {
                        authRequired: true,
                        pageTitle: 'Atendimento',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/meta/template-messages'),
                    name: 'meta-template-messages',
                    component: () => import('@/views/meta-template-messages/List.vue'),
                    meta: {
                        authRequired: true,
                        pageTitle: 'Modelos de Mensagens da Meta',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/meta/template-messages/add'),
                    name: 'meta-template-messages-add',
                    component: () => import('@/views/meta-template-messages/Add.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Modelos Mensagens', url: formatRouteTenantPath('/meta/template-messages')},
                            { title: 'Adicionar Novo', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Adicionar Modelo de Mensagens',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/user-departments/list'),
                    name: 'user-departments-list',
                    component: () =>
                        import ('@/views/user-departments/UserDepartmentsList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Departamentos' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Departamentos',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/roles/list'),
                    name: 'roles-list',
                    component: () =>
                        import ('@/views/roles/RolesList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Permissões' },
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Permissões',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/roles/add'),
                    name: 'roles-add',
                    component: () =>
                        import ('@/views/roles/RolesForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Permissões', url: formatRouteTenantPath('/roles/list') },
                            { title: 'Adicionar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Adicionar Permissões',
                        rule: 'check'
                    }
                },
                {
                    path: formatTenantPath('/roles/edit/:id'),
                    name: 'roles-update',
                    component: () =>
                        import ('@/views/roles/RolesForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Permissões', url: formatRouteTenantPath('/roles/list') },
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Permissões',
                        rule: 'check'
                    }
                },
                // =============================================================================
                // Pages Routes
                // =============================================================================
                {
                    path: formatTenantPath('/user-settings'),
                    name: 'user-settings',
                    component: () =>
                        import ('@/views/pages/user-settings/UserSettings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: formatRouteTenantPath('/') },
                            { title: 'Configurações' },
                            { title: 'Usuário', active: true }
                        ],
                        pageTitle: 'Configurações do Usuário',
                        rule: 'all'
                    }
                }
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () =>
                import ('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: formatTenantPath('/login'),
                    name: 'login',
                    component: () =>
                        import ('@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/unsubscribe/email'),
                    name: 'unsubscribe',
                    component: () =>
                        import ('@/views/pages/Unsubscribe.vue'),
                    meta: {
                        rule: 'all'
                    }
                },

                {
                    path: formatTenantPath('/forgot'),
                    name: 'forgot-password',
                    component: () =>
                        import ('@/views/pages/forgot/ForgotPassword.vue'),
                    meta: {
                        rule: 'all'
                    }
                },

                {
                    path: formatTenantPath('/forgot/*'),
                    name: 'forgot-new-password',
                    component: () =>
                        import ('@/views/pages/forgot/NewPassword.vue'),
                    meta: {
                        rule: 'all'
                    }
                },

                {
                    path: formatTenantPath('/redirect'),
                    name: 'page-redirect',
                    component: () =>
                        import ('@/views/pages/Redirect.vue'),
                    meta: {
                        rule: 'all'
                    }
                },

                {
                    path: '/pages/comingsoon',
                    name: 'page-coming-son',
                    component: () =>
                        import ('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () =>
                        import ('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () =>
                        import ('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/tenant-invalid',
                    name: 'page-error-tenant-invalid',
                    component: () =>
                        import ('@/views/pages/ErrorTenantInvalid.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: formatTenantPath('/not-authorized'),
                    name: 'page-not-authorized',
                    component: () =>
                        import ('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'all'
                    }
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none"
    }

    const userInfo = JSON.parse(localStorage.getItem("userInfo"))
    if (userInfo && userInfo.id !== undefined) {
        connect()
    }
})


router.beforeEach((to, from, next) => {
    // if (to.meta.authRequired) {
    //     if (!localStorage.getItem('accessToken')) {
    //         router.push({ path: getCurrentTenant() + '/login', query: { to: to.path } })
    //     }
    // }
    return next()
})

export default router
